import { render, staticRenderFns } from "./addSku.vue?vue&type=template&id=56f70566&scoped=true"
import script from "./addSku.vue?vue&type=script&lang=js"
export * from "./addSku.vue?vue&type=script&lang=js"
import style0 from "./addSku.vue?vue&type=style&index=0&id=56f70566&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f70566",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56f70566')) {
      api.createRecord('56f70566', component.options)
    } else {
      api.reload('56f70566', component.options)
    }
    module.hot.accept("./addSku.vue?vue&type=template&id=56f70566&scoped=true", function () {
      api.rerender('56f70566', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/distribution/qty/addSku.vue"
export default component.exports